import httpClient from "./httpClient/api";

const getUser = () => httpClient.get("/user");

export default {
  getUser
}